import React from 'react'
import { Box, Paper } from '@material-ui/core'

export function BarTooltip(id: string, value: string): React.ReactElement {
  return (
    <Paper>
      <Box p={1}>
        <Box>{id}</Box>
        <Box>{value}</Box>
      </Box>
    </Paper>
  )
}
